import { HOST_URL_STORAGE } from '@/const';

function getStorageUrl(key: string) {
  return `${HOST_URL_STORAGE}/${key}`;
}

export default getStorageUrl;
